/** angular */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
/** angular */

/** components */
import { MainComponent } from './main.component';
import { DsUserAccountComponent } from './components/ds-user-account/ds-user-account.component';
/** end components */

/** resolvers */
import { ProjectListResolver } from '@shared/resolvers/project-list.resolver';
import { BydUserResolver } from '@sixense/ds-roazhon-service';
/** end resolvers */

const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    resolve: { projectListModel: ProjectListResolver },
    children: [
      {
        path: 'projects',
        loadChildren: () => import('@modules/ds-projects/ds-projects.module').then((module) => module.DsProjectsModule),
      },
      {
        path: 'account/infos',
        resolve: { BydUserResolver },
        component: DsUserAccountComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainRoutingModule {}
